var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComplianceDelete(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "m10.7 11.382-.021.091c-.09.298-.43.527-.847.527H4.33l-.123-.007c-.4-.044-.706-.301-.744-.611L1.72.442.655.558l1.742 10.94.028.15c.18.788.979 1.352 1.904 1.352h5.503l.172-.006c.906-.07 1.657-.682 1.758-1.496L13.505.558 12.441.442 10.7 11.382z",
    id: "n2t7uoyu2a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.34 0-.134.007C.505.079 0 .712 0 1.439V2.5h1.071V1.439l.007-.095c.03-.21.157-.344.261-.344h2.679l.045.008c.108.038.223.2.223.431V2.5h1.071V1.439l-.005-.135C5.29.59 4.742 0 4.018 0H1.339z",
    id: "trhb382okc"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 4,
    fill: "#FF3F6D"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.071 8)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "3a87x5cuab",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n2t7uoyu2a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#n2t7uoyu2a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#3a87x5cuab)",
    d: "M-4.701 18h23.564V-4.558H-4.701z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.357 6)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "53ajhzx4od",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#trhb382okc"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#trhb382okc"
  }), /*#__PURE__*/React.createElement("path", {
    mask: "url(#53ajhzx4od)",
    d: "M-5.357 7.5h16.071V-5H-5.357z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M6.065 9h13.942V7.999H6.066zM13.687 17.945l1.065.11 1.072-7-1.065-.11zM10.473 11.055l1.072 7 1.065-.11-1.072-7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplianceDelete);
export default __webpack_public_path__ + "static/media/compliance-delete.591f3312.svg";
export { ForwardRef as ReactComponent };